module.exports = __webpack_public_path__ + "static/img/pdf-image-placeholder.94190da.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/pdf-image-placeholder.png
// module id = Z2ZD
// module chunks = 57